export const deleteInvestigationRoadAccidentService = (fetch) => async (id) => {
  try {
    const response = await fetch({
      url: `/api/v1/siniestros-viales/investigaciones/${id}`,
      method: "delete",
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
